import { compose, mapProps, withState, withHandlers, lifecycle } from 'recompose';
import camelize from 'camelize';
import config from '../../../config';
import { withSpinnerOnAjax, withFetchOnMount } from '../../Common/Spinner';
import { getConfigValue } from './ConfigsApi';

export const getSubscriptionsUrl = `${config.localeApi}/subscriptions`;
export const getUserSubscriptionsUrl = `${config.localeApi}/userSubscriptions`;
export const getUpSellUrl = `${config.localeApi}/subscriptions/UpSell`;

const getData = () => $.get(getSubscriptionsUrl)
  .fail((resp) => {
    const { errors = null } = resp.responseJSON;
    if (errors) {
      const msg = Object.keys(errors)
        .map((key) => (errors[key].join('')))
        .join('<br/>');
      toastr.warning(msg);
    }
  });

const getUserSubscriptionsData = () => $.get(getUserSubscriptionsUrl)
  .fail((resp) => {
    const { errors = null } = resp.responseJSON;
    if (errors) {
      const msg = Object.keys(errors)
        .map((key) => (errors[key].join('')))
        .join('<br/>');
      toastr.warning(msg);
    }
  });

export const withSubscriptionData = compose(
  withState('subscription', 'setSubscription', false),
  withSpinnerOnAjax('getData', getData),
  withHandlers({
    handleShown: ({getData, setSubscription}) => () => {
      window.scrollTo({ top: 0, right: 0, behavior: 'smooth' });
      getData()
      .done(response => {
        setSubscription(camelize(response.data))
      })
    }
  })
);

const getShippingCreditEnabled = () => {
  const configKey = 'pass-shipping-credit-feature';
  return getConfigValue(configKey);
}

export const withUserSubscriptionsData = compose(
  withState('subscriptions', 'setSubscriptions', []),
  withState('shippingCreditEnabled', 'setShippingCreditEnabled', false),
  withSpinnerOnAjax('getUserSubscriptionsData', getUserSubscriptionsData),
  withSpinnerOnAjax('getShippingCreditEnabled', getShippingCreditEnabled),
  withHandlers({
    handleShown: ({getUserSubscriptionsData, setSubscriptions, getShippingCreditEnabled, setShippingCreditEnabled}) => () => {
      window.scrollTo({ top: 0, right: 0, behavior: 'smooth' });
      getUserSubscriptionsData()
      .done(response => {
        setSubscriptions(camelize(response.data))
      });
      getShippingCreditEnabled()
      .done( response => {
        const shippingCreditEnabled = response.length > 0 && response[0].toLowerCase() === 'true';
        setShippingCreditEnabled(shippingCreditEnabled);
      })
    }
  }),
);

export const addSubscriptionToCart = (subscriptionId, upSellStatus = false) => {
  return $.ajax({
    url: `${config.localeApi}/cart/subscription`,
    data: {
      subscription_id: subscriptionId,
      is_upsell: upSellStatus ? 1 : 0,
    },
    method: 'POST',
    dataType: 'json',
  });
};

const getUpSellSubscriptionsData = () => $.get(getUpSellUrl)
  .fail((resp) => {
    const { errors = null } = resp.responseJSON;
    if (errors) {
      const msg = Object.keys(errors)
        .map((key) => (errors[key].join('')))
        .join('<br/>');
      toastr.warning(msg);
    }
  });

export const withUpSellSubscriptionsData = compose(
  withFetchOnMount(getUpSellSubscriptionsData),
  mapProps(({ loading, data, ...keys }) => ({
    upsellInfo: camelize(data.data),
    ...keys,
  })),
);



// WEBPACK FOOTER //
// ./src/Common/Providers/SubscriptionApi.js